import React from "react"
import { Button, Row, Col } from "reactstrap"
import FormItem from "../../Common/FormItem"
import useProfileSettings from "./useProfileSettings"

export default function ProfileSettings({ notify, customer, auth }) {
  const { name, setName, email, setEmail, phone, setPhone, updateProfile } =
    useProfileSettings({ notify, customer, auth })
  return (
    <Row form className="mb-3">
      <Col md="12">
        <FormItem
          id="customer-name"
          placeholder="Max Muller"
          label="NAME"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </Col>
      <Col md="12">
        <FormItem
          id="customer-email"
          placeholder="noztickprofile@gmail.com"
          label="EMAIL"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled
        />
      </Col>
      <Col md="12">
        <FormItem
          id="customer-phone"
          placeholder="+1 (3423) 323 233"
          label="PHONE NUMBER"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </Col>
      <Col col="12" style={{ margin: "20px 0" }}>
        <Button className="float-right" color="primary" onClick={updateProfile}>
          Update
        </Button>
      </Col>
    </Row>
  )
}
